import React, { Fragment, useCallback } from 'react';
import * as S from './style';

import { ReactComponent as CheckOn } from 'assets/img/common/btn_checkbox_on.svg';
import { ReactComponent as CheckOff } from 'assets/img/common/btn_checkbox_off.svg';
import { ReactComponent as CheckBludArrow } from 'assets/img/common/ic_check_arrow_blue.svg';

export type TBoxType = 'TAG' | 'CAPTION' | 'RADIO';

export interface Props {
    checked: boolean;
    boxType?: TBoxType;
    value?: any;
    disabled?: boolean;
    title?: string;
    caption?: string;
    onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>, value?: any, checked?: boolean) => void;
}

function ChkBox({ checked, value, disabled, boxType, title, caption, onClick }: Props): React.ReactElement {
    const onClickCallback = useCallback(
        (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            if (!disabled) {
                onClick && onClick(e, value, checked);
            }
        },
        [checked, disabled, onClick, value]
    );

    return (
        <S.CheckBoxWrapper checked={checked} boxType={boxType} onClick={onClickCallback}>
            {(() => {
                if (boxType === 'TAG') {
                    return <S.TagCheckLabel>{title}</S.TagCheckLabel>;
                } else if (boxType === 'CAPTION') {
                    return (
                        <Fragment>
                            <S.CaptionCheckDimd />
                            <S.IconWrapper>{checked ? <CheckOn /> : <CheckOff />}</S.IconWrapper>
                            <S.LabelWrapper>
                                <S.LabelTitle fontStyle={'body2'} contents={title} />
                                {caption ? <S.LabelCaption fontStyle={'caption'} contents={caption} /> : null}
                            </S.LabelWrapper>
                        </Fragment>
                    );
                } else if (boxType === 'RADIO') {
                    return <S.RadioCheckIcon />;
                } else {
                    return (
                        <S.DefaultWrapper>
                            {checked ? (
                                <S.DefaultIconWrapper>
                                    <CheckBludArrow />
                                </S.DefaultIconWrapper>
                            ) : null}
                            <S.LabelWrapper>
                                <S.LabelTitle fontStyle={'body2'} contents={title} />
                            </S.LabelWrapper>
                        </S.DefaultWrapper>
                    );
                }
            })()}
        </S.CheckBoxWrapper>
    );
}

export default ChkBox;
